import newsApi from "@/api/newsApi";
import { chunkArray, getSearchParam, keysVsVal } from "@/utils";
import { isShowNews1 } from "@/utils/isShowNews1";

// 全球英语：待定
// 印度英语
const en_in = keysVsVal(["en"], "EN-IN");
// 印尼语
const in_id = keysVsVal(["id", "in"], "IN-ID");
// 印地语
const hindi_in = keysVsVal(["hi"], "Hindi-IN");

const idVlsDomain_in = keysVsVal(["id-v-ls.comfortweather.com"], "IN-ID");

const all_news_lan = {
  ...en_in,
  ...in_id,
  ...hindi_in,
};

const lan = getSearchParam("lan") || "";
const { subdomain } = useSubdomain();
const newsListState = atom({
  scrollNewsListY: 0,
  loadingNewsList: false,
  isEmptyNewsList: false,
  errMsgNewsList: "",
  resData: [],
  total: 0,
  queryParams: {
    page: 0,
    lan: isShowNews1().validMain
      ? all_news_lan[lan]
      : isShowNews1().isIdVls
        ? idVlsDomain_in[`${subdomain}.comfortweather.com`]
        : "EN-IN",
  },
});
const useNewsListCtrl = () => {
  const [newsList, setNewsList] = useAtom(newsListState);
  return {
    scrollNewsListY: newsList.scrollNewsListY,
    loadingNewsList: newsList.loadingNewsList,
    isEmptyNewsList: newsList.isEmptyNewsList,
    errMsgNewsList: newsList.errMsgNewsList,
    resData: newsList.resData,
    total: newsList.total,
    queryParams: newsList.queryParams,
    setNewsList,
  };
};

function useNewsListHook() {
  const { queryParams, setNewsList } = useNewsListCtrl(); // 在组件顶层调用Hook
  async function loadNewsList() {
    try {
      const res = await newsApi.queryList(queryParams);
      if (!isEmptyType(res?.data?.rows)) {
        // 保留原有queryParams
        setNewsList(prev => ({
          ...prev,
          loadingNewsList: false,
          isEmptyNewsList: false,
          errMsgNewsList: "",
          resData: chunkArray(res.data.rows, 5),
          total: res.data.count,
        }));
      } else {
        setNewsList(prev => ({
          ...prev,
          scrollNewsListY: 0,
          loadingNewsList: false,
          isEmptyNewsList: true,
          errMsgNewsList: "",
        }));
      }
      return res;
    } catch (error) {
      console.error("Failed to fetch news:", error);
      setNewsList(prev => ({
        ...prev,
        scrollNewsListY: 0,
        loadingNewsList: false,
        isEmptyNewsList: false,
        errMsgNewsList: error instanceof Error ? error.message : "未知错误",
      }));
    }
  }

  return {
    loadNewsList,
  };
}

export { useNewsListCtrl, useNewsListHook, all_news_lan, idVlsDomain_in };
